<template>
    <div>
        <div class="p-3 news__block__card h-100 cursor-pointer d-flex flex-column justify-content-between gap-3">
            <div class="news__block__card__imgBox d-flex position-relative justify-content-center">
                <button class="news__block__card__imgBox-btn dark border-0 position-absolute">
                    News
                </button>
                <img :src="newsImage" class="news__block__card__imgBox-img" />
            </div>

            <div class="news__block__card__imgBox-text d-flex justify-content-between align-items-end">
                <div class="d-flex justify-content-between align-items-center w-100 gap-3">
                    <p class="align-content-center mb-0">
                        {{ newsText }}
                    </p>
                    <button class="news__block__card__imgBox-icon m-0 p-1">
                        <i class="fa-solid fa-chevron-right text-muted px-1"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        newsBtnText: String,
        newsImage: String,
        newsText: String,
    },
};
</script>
